export const REQUEST = 'AUTH_VERIFY_MAGIC_LINK_REQUEST';
export const SUCCESS = 'AUTH_VERIFY_MAGIC_LINK_SUCCESS';
export const FAILURE = 'AUTH_VERIFY_MAGIC_LINK_FAILURE';

export const fetchRequest = (token) => ({
  type: REQUEST,
  payload: { token }
});

export const fetchSuccess = (data) => ({
  type: SUCCESS,
  payload: data
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
